import React from 'react';
import { Helmet } from 'react-helmet-async';
import { IntlProvider } from 'react-intl';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import messages from 'GlobalNavMessages';
import { SubscriptionClient } from 'subscriptions-transport-ws';
import { BackendSubscriptionClientProvider } from '@99designs/apps/spa/common/ApolloClient/BackendSubscriptionClientContext';
import { ErrorBoundary } from '@99designs/apps/spa/common/ErrorBoundary';
// eslint-disable-line import/no-unresolved
import Routes from '@99designs/apps/spa/routes';
import { UIProvider } from '@99designs/emu';
import { formatMessage } from '@99designs/frontend-components/i18n';
import { Site, SiteConfig } from '@99designs/site-navigation/lib/Site';
import { SiteProvider } from '@99designs/spa-common';
import { ViewerProviderQuery } from '@99designs/viewer';

interface Props {
    language: string;
    siteConfig: SiteConfig;
    backendSubscriptionClient?: SubscriptionClient;
}

class App extends React.Component<Props> {
    render() {
        const site = new Site(this.props.siteConfig);
        return (
            <React.StrictMode>
                <IntlProvider locale={this.props.language} messages={messages}>
                    <ErrorBoundary site={site}>
                        <BackendSubscriptionClientProvider
                            value={this.props.backendSubscriptionClient}
                        >
                            <ViewerProviderQuery>
                                <SiteProvider site={site}>
                                    <UIProvider
                                        translationStrings={{
                                            Alert: {
                                                Dismiss: __('Dismiss'),
                                            },
                                            ButtonGroup: {
                                                Menu: __('More options'),
                                            },
                                            Modal: {
                                                Close: __('Close'),
                                            },
                                            Rating: {
                                                Legend: __('Rating'),
                                                ReadOnlyLabel: (value: number) =>
                                                    formatMessage(__('{value} out of 5 stars'), {
                                                        value,
                                                    }),
                                                Value: (value: number) =>
                                                    value === 1
                                                        ? __('1 star')
                                                        : formatMessage(__('{value} stars'), {
                                                              value,
                                                          }),
                                            },
                                            Select: {
                                                ClearAll: __('Clear all'),
                                                Open: __('Open'),
                                                Remove: __('Remove'),
                                            },
                                            Pagination: {
                                                Next: __('Next'),
                                                Previous: __('Previous'),
                                            },
                                        }}
                                    >
                                        <Helmet
                                            titleTemplate="%s | 99designs"
                                            defaultTitle="99designs"
                                        />
                                        <Routes site={site} />
                                    </UIProvider>
                                </SiteProvider>
                            </ViewerProviderQuery>
                        </BackendSubscriptionClientProvider>
                    </ErrorBoundary>
                </IntlProvider>
            </React.StrictMode>
        );
    }
}

export default App;
